import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { NavigationItem } from '@features/navigation/NavigationItem';
import { ToggleStateProvider } from '@features/navigation/ToggleStateProvider';
import { NavigationEntity, useSidebarNavigationEntities } from 'hooks/useNavigationEntities';

interface Props {
  onSelect?: (entity: NavigationEntity) => void;
}
const NavigationList = observer(({ onSelect }: Props) => {
  const { root, byId, selectedNavigationEntity } = useSidebarNavigationEntities();

  return (
    <Flex flexDirection="column" gap={2}>
      {root.children.map((child) => {
        const entity = byId[child.id];
        if (entity == null) {
          return null;
        }
        return (
          <NavigationItem
            key={`${entity.id}`}
            entity={entity}
            onSelect={onSelect}
            selectedNavigationEntity={selectedNavigationEntity}
          />
        );
      })}
    </Flex>
  );
});

export const PageNavigation = React.memo(({ onSelect }: Props) => {
  return (
    <ToggleStateProvider>
      <NavigationList onSelect={onSelect} />
    </ToggleStateProvider>
  );
});

PageNavigation.displayName = 'PageNavigation';
